import { Component, OnInit } from '@angular/core';
import { SubscriptionRequest } from "../../models/SubscriptionRequest"
import { SubscriptionAccount } from "../../models/SubscriptionAccount"

import { FormGroup, FormControl } from '@angular/forms';
import { IsoeventsubscriptionmangementserviceService } from '../../services/isoeventsubscriptionmangementservice.service';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionEvent } from 'src/app/models/SubscriptionEvent';

@Component({
  selector: 'app-manageallsubscriptions',
  templateUrl: './manageallsubscriptions.component.html',
  styleUrls: ['./manageallsubscriptions.component.css']
})
export class ManageallsubscriptionsComponent implements OnInit {

  userEmail: string = null;
  userUniqueName: string = null;
  modifiedEventIds: string[] = [];
  accountsWithEvents: string[] = [];
  isoAccounts: SubscriptionAccount[] = [];
  model = new SubscriptionRequest();
  selectedEvents = null;
  submitted: boolean = false;
  requestProcessed: boolean = false;
  messageToDisplay: string = "";
  requestFailed: boolean = false;
  dataLoaded: boolean = false;

  constructor(private eventService: IsoeventsubscriptionmangementserviceService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.userEmail = params.emailAddress;
        this.userUniqueName = params.uniqueName;
      }
      );


    this.eventService.getAllEventsDetails().subscribe(data => {
      this.isoAccounts = data;
 
      console.log('Accounts...');

      console.log(data);

      this.isoAccounts.forEach(acc => {
        if (acc.listOfSubcriptionEvents && acc.listOfSubcriptionEvents.length>0  && this.accountsWithEvents.indexOf(acc.accountId) < 0) {

          var evntsShowAlways =  acc.listOfSubcriptionEvents.filter(e=>e.showEventOnlyIfOptedIn==false);
          if(evntsShowAlways && evntsShowAlways.length>0){
            this.accountsWithEvents.push(acc.accountId);
          }

        }
      }); 

    });

    this.eventService.getAllSubscriptionPerferencesAsync(this.userEmail, this.userUniqueName).subscribe(data => {
      this.model = data

      if (!this.model) {
        this.requestFailed = true;
        this.messageToDisplay = "No matching subscription details found.";
        this.dataLoaded = true;
      }
      else {
        this.dataLoaded = true;
        this.model.subscribedEvents.forEach(evt => {
          if (this.accountsWithEvents.indexOf(evt.accountId) < 0) {
            this.accountsWithEvents.push(evt.accountId);
          }
        });


      }

      //accountsWithEvents

      console.log(this.model);
    });
  }


  submit(subscriptionForm) {
    this.dataLoaded = false;
    this.eventService.UpdateAllSubscriptionPreferencesAsync(this.model).subscribe(data => {
      this.dataLoaded = true;
      this.requestProcessed = true;
      this.messageToDisplay = "Request has been processed successfully";
    }); 
  }


  ////Method to add the event name to the selected list
  onEventSelectionChange(e: any, accountId: string, eventId: string) {

    let uniqueEventName = e.currentTarget.value;
    if (this.modifiedEventIds.indexOf(eventId) < 0) {
      this.modifiedEventIds.push(eventId);
    }

    if (!this.model.eventNames) {
      this.model.eventNames = [];
    }

    if (e.currentTarget.checked) {

      this.model.unsubscribedEvents = this.model.unsubscribedEvents.filter(evt => evt.eventName != e.currentTarget.value && evt.accountId != accountId);
      this.model.eventNames.push(eventId);
    }
    else {

      let subEvent = new SubscriptionEvent();
      subEvent.accountId = accountId;
      subEvent.eventName = e.currentTarget.value;
      subEvent.eventId = eventId;

      this.model.eventNames = this.model.eventNames.filter(eventName => eventName != eventId);
      this.model.unsubscribedEvents.push(subEvent);
    }
    console.log(this.model.unsubscribedEvents);
    this.selectedEvents = this.model.eventNames.join();
  }

}
